// src/helpers/activeTicketTypesCache.ts
// Cache-first loader cho danh sách loại vé đang mở (TicketType/GetActiveTicketTypes) — dùng ở
// Issuance Plans để tránh gọi lại API mỗi lần vào màn (trước đây chỉ SystemConfig được cache,
// còn danh sách loại vé thì luôn fetch lại nên màn vẫn chậm).

import { CacheService } from 'services/cache';
import { CacheConfig } from 'services/cache/CacheConfig';
import { setActiveTicketTypes } from 'slices/ticketType/reducer';
import { fetchActiveTicketTypes } from 'slices/ticketType/thunk';
import { TicketType } from 'pages/TicketTypeManagement/types';

const getPayloadItems = (payload: any): TicketType[] => payload?.items || payload?.data || payload || [];

export const loadActiveTicketTypesWithCache = async (dispatch: any): Promise<void> => {
  const cacheKey = CacheConfig.ACTIVE_TICKET_TYPES.key;
  const cacheTtl = CacheConfig.ACTIVE_TICKET_TYPES.ttl;

  const cached = CacheService.get<TicketType[]>(cacheKey);

  // Chi dung cache neu la mang hop le — phong truong hop cache cu (truoc ban fix nay) da lo luu
  // nham message loi (string) do khong kiem tra fulfilled/rejected truoc khi set cache.
  if (cached.cached && Array.isArray(cached.data)) {
    dispatch(setActiveTicketTypes(cached.data));
    return;
  }

  const result = await dispatch(fetchActiveTicketTypes());
  // QUAN TRONG: chi cache khi thunk thuc su fulfilled — action rejected (rejectWithValue) cung co
  // result.payload (message loi dang string), neu chi kiem tra "truthy" se cache nham string do,
  // khien lan sau doc cache ra activeTicketTypes la string thay vi mang (".map is not a function").
  if (fetchActiveTicketTypes.fulfilled.match(result)) {
    const items = getPayloadItems(result.payload);
    CacheService.set(cacheKey, items, cacheTtl);
  }
};
